import { React, useState, useEffect } from "react";
import "./SMESessions.css";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Button, Typography } from "@mui/material";
import Axios from "axios";
import {
 getNominationList,
 fetchUserListByCourse,
 fetchWaitingForApprovalList,
 getNominatedCountSME,
 getCountSME,
} from "../Redux/SmeSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import SMENominationList from "./SMENominationList";
import { useMsal } from "@azure/msal-react";
import { updateLoginUserName } from "../Redux/BussinessPOCSlice";
import { getNominatedCount, getCount } from "../Redux/THSlice";
//const baseURL = "http://localhost:15301";
const baseURL = "https://lkmtraining.nomination.accenture.com/LKMtrainingNomination-apis";

const SMESessions = () => {
 const dispatch = useDispatch();
 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 const [username, setuserName] = useState();
 //  const trainingList = useSelector((state) => state.sme.trainingList);
 //  const username = useSelector((state) => state.poc.enterpriseID);

 const [trainingList, setTrainingList] = useState([]);
 const [courseCodeNm, setCourseCodeNm] = useState();
 const [date, setDate] = useState();

 const [page, setPage] = useState(0);
 const [rowsPerPage, setRowsPerPage] = useState(10);
 //const [coursewiseList, setcoursewiseList] = useState();
 const [nominationSelected, setNominationSelected] = useState(false);
 const [selectedCourseName, setSelectedCourseName] = useState(null);
 const [month, setMonth] = useState("");
 const theme = createTheme({
  typography: {
   fontFamily: "Graphik-Regular",
  },
 });

 const handleChangePage = (event, newPage) => {
  setPage(newPage);
 };
 useEffect(() => {
  if (activeAccount) {
   console.log("Active acocunt is", activeAccount.idTokenClaims.enterpriseID);
   setuserName(activeAccount.idTokenClaims.enterpriseID);
  } else {
   setuserName(null);
  }
 }, [activeAccount]);
 //  useEffect(() => {
 //   if (activeAccount) {
 //    dispatch(updateLoginUserName(activeAccount.idTokenClaims.enterpriseID));
 //   } else {
 //    dispatch(updateLoginUserName(null));
 //   }
 //  }, [activeAccount]);
 const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
 };

 const handleChangeMonth = (event) => {
  setMonth(event.target.value);
 };

 const handleNominationCLick = (course, date, courseName) => {
  setCourseCodeNm(course);
  setDate(date);
  setSelectedCourseName(courseName);
  //dispatch(fetchUserListByCourse(course, date));
  dispatch(fetchWaitingForApprovalList(course, date));
  setNominationSelected(true);
  dispatch(getCountSME(course, date));
  dispatch(getNominatedCountSME(course, date));
 };
 useEffect(() => {
  //   dispatch(getNominationList());
  Axios.get(`${baseURL}/fetchTrainingListSME/${username}`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })
   .then((res) => {
    res.data.map((val, i) => {
     val.id = i + 1;
    });
    console.log("res from useeffect", res.data);
    setTrainingList(res.data);
   })
   .catch((err) => {
    console.error("error is", err);
   });
 }, [username]);

 const goBack = () => {
  Axios.get(`${baseURL}/fetchTrainingListSME/${username}`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })
   .then((res) => {
    res.data.map((val, i) => {
     val.id = i + 1;
    });
    console.log("fetchTrainingListSME", res.data);
    setTrainingList(res.data);
   })
   .catch((err) => {
    console.error("error is", err);
   });
  setNominationSelected(false);
 };

 return (
  <>
   <ThemeProvider theme={theme}>
    <div className="banner training-banner-box">
     <img
      src={process.env.PUBLIC_URL + "/images/Home/training-banner.png"}
      alt="banner"
      className="home-banner"
     />
     <h1 className="banner-content">Course SME View</h1>
    </div>
    {nominationSelected ? (
     <Box className="goback_section">
      <Button className="goback_button" onClick={() => goBack()}>
       Go Back
      </Button>
     </Box>
    ) : (
     ""
    )}
    {!nominationSelected ? (
     <Box className="SME_main">
      <Box className="SME_session_container">
       {/* <Typography variant="h3" component="p" className="SME_session_header">
        My Training Sessions
       </Typography> */}
       <h3 className="SME_session_header">My Training Sessions</h3>
       {/* <Typography className="upload_section_para">
       This section allows the SMEs to review the skills of the candidates against a course to which the nominations are uploaded. The tool allows you to approve / reject the nominations based on their skills as defined by the course pre-requisites to attend the training.
       </Typography> */}
       <p className="upload_section_para">
        This section allows the SMEs to review the skills of the candidates against a
        course to which the nominations are uploaded. The tool allows you to approve /
        reject the nominations based on their skills as defined by the course
        pre-requisites to attend the training.
       </p>
      </Box>
      {/* <Box className="select_month_section">
       <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Month</InputLabel>
        <Select
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         value={month}
         label="Month"
         onChange={handleChangeMonth}
         displayEmpty
        >
         <MenuItem value={1}>January</MenuItem>
         <MenuItem value={2}>February</MenuItem>
         <MenuItem value={3}>March</MenuItem>
         <MenuItem value={4}>April</MenuItem>
         <MenuItem value={5}>May</MenuItem>
         <MenuItem value={6}>June</MenuItem>
         <MenuItem value={7}>July</MenuItem>
         <MenuItem value={8}>August</MenuItem>
         <MenuItem value={9}>September</MenuItem>
         <MenuItem value={10}>October</MenuItem>
         <MenuItem value={11}>November</MenuItem>
         <MenuItem value={12}>December</MenuItem>
        </Select>
       </FormControl>
      </Box> */}
      {trainingList.length != 0 && trainingList != undefined ? (
       <Box className="SME_table">
        <TableContainer component={Paper}>
         <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
           <TableRow>
            <TableCell align="center" sx={{ width: "6%" }}>
             Sl No
            </TableCell>
            <TableCell align="center" sx={{ width: "14%" }}>
             Course Code
            </TableCell>
            <TableCell align="center" sx={{ width: "14%" }}>
             Session Code
            </TableCell>
            <TableCell align="center" sx={{ width: "32%" }}>
             Course Name
            </TableCell>
            <TableCell align="center" sx={{ width: "8%" }}>
             Start Date
            </TableCell>
            <TableCell align="center" sx={{ width: "8%" }}>
             End Date
            </TableCell>
            <TableCell align="center" sx={{ width: "10%" }}>
             Delivery Mode
            </TableCell>
            <TableCell align="center" sx={{ width: "8%" }}>
             Duration
            </TableCell>
            <TableCell
             align="center"
             className="fix"
             //  sx={{ width: "8%", background: "#7300BD" }}
             sx={{ width: "8%" }}
            ></TableCell>
           </TableRow>
          </TableHead>
          <TableBody>
           {trainingList != undefined &&
            trainingList != "" &&
            trainingList
             .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
             .map((row, index) => (
              <TableRow
               sx={{
                cursor: row.flag == 1 ? "pointer" : "cursor",
                pointerEvents: row.flag == 1 ? "auto" : "none",
               }}
               key={index}
               //disabled={row.flag != 1}
               onClick={() => {
                handleNominationCLick(row.courseCode, row.startDate, row.courseName);
               }}
              >
               <TableCell align="center" scope="row">
                {page * rowsPerPage + index + 1}.
               </TableCell>
               <TableCell align="center" scope="row">
                {row.courseCode}
               </TableCell>
               <TableCell align="center">{row.sessionCode}</TableCell>
               <TableCell align="center">{row.courseName}</TableCell>
               <TableCell align="center">{row.startDate}</TableCell>
               <TableCell align="center">{row.endDate}</TableCell>
               <TableCell align="center">{row.deliveryMode}</TableCell>
               <TableCell align="center">{row.duration} Hrs</TableCell>
               <TableCell
                align="center"
                className="fix"
                sx={{ cursor: row.flag == 1 ? "pointer" : "cursor" }}
                //  onClick={() => {
                //   handleNominationCLick(row.courseCode);
                //  }}
               >
                <Typography
                 sx={{
                  border: row.flag == 1 ? "solid 1px #A6A6A6 " : "none",
                  borderRadius: "5px",
                  fontSize: "14px",
                  padding: "5px",
                  background: "#fff",
                  color: row.flag == 1 ? "#2392ff" : "orange",
                  textAlign: "center",
                  //    color: item.status == 1 ? "#72A3E3" : item.status == 3 ? "red" : "yellow",
                 }}
                >
                 {row.flag == 1 ? "Waiting for Approval" : "#"}
                </Typography>
               </TableCell>
              </TableRow>
             ))}
          </TableBody>
         </Table>
        </TableContainer>
        <TablePagination
         className="sme_pagination"
         //labelRowsPerPage={"Page No:"}
         rowsPerPageOptions={[10, 25, 100]}
         component="div"
         count={trainingList != 0 ? trainingList.length : null}
         page={page}
         onPageChange={handleChangePage}
         rowsPerPage={rowsPerPage}
         onRowsPerPageChange={handleChangeRowsPerPage}
         //  nextIconButtonProps={{ style: { visibility: "hidden" } }}
         //  backIconButtonProps={{ style: { visibility: "hidden" } }}
         sx={{
          ".MuiTablePagination-spacer": {
           display: "none",
          },
         }}
        />
       </Box>
      ) : (
       <Stack
        justifyContent={"center"}
        alignItems={"center"}
        sx={{ marginTop: "30px", marginBottom: "100px" }}
       >
        <Stack
         spacing={2}
         justifyContent={"center"}
         alignItems={"center"}
         sx={{
          border: "solid 1px #DEDEDE",
          borderRadius: "5px",
          width: "70%",
          padding: "30px",
         }}
        >
         <img style={{ width: "100px" }} src="/images/POC/norecords.png"></img>
         <Stack direction={"row"} spacing={1}>
          <img
           style={{ width: "18px", height: "21px", marginTop: "3px" }}
           src="/images/POC/norecordsalert.png"
          ></img>
          <Typography sx={{ fontSize: "20px" }}>No Records Found!!!</Typography>
         </Stack>
        </Stack>
       </Stack>
      )}
     </Box>
    ) : (
     <SMENominationList
      courseCodeNm={courseCodeNm}
      date={date}
      selectedCourseName={selectedCourseName}
     />
    )}
   </ThemeProvider>
  </>
 );
};

export default SMESessions;
